import React from 'react';
import { Tabs } from 'antd'
import { app } from 'xadmin'
import './NavTabs.css'

const NavTabsComponent = props => {
  const { max } = props
  const home = { key: "home", title: "首页", url: "/app/dashboard" }
  const currentUrl = location.hash?.slice(1)
  const _historyUrls = _.compact(_.uniqBy([home, ...(window.__history__ || [])], 'key'))
  const [historyUrls, setHistoryUrls] = React.useState(max ? _historyUrls?.slice(0, max) : _historyUrls)
  const [activeKey, setActiveKey] = React.useState('')

  React.useEffect(() => {
    setHistoryUrls(max ? _historyUrls?.slice(0, max) : _historyUrls)
  }, [max, JSON.stringify(_historyUrls || [])])

  React.useEffect(() => {
    setActiveKey(k => _historyUrls.some(h => h.url == currentUrl) ? currentUrl : k)
  }, [currentUrl, JSON.stringify(historyUrls)])

  const onChange = key => {
    key && app.go(key)
  }

  const onEdit = (targetKey, action) => {
    if (action == 'remove') {
      let newActiveKey = activeKey
      let lastIndex = -1
      historyUrls.forEach((item, i) => {
        if (item.url === targetKey) {
          lastIndex = i - 1
        }
      });
      const newPanes = historyUrls.filter(item => item?.url !== targetKey)
      if (newPanes.length && newActiveKey === targetKey) {
        if (lastIndex >= 0) {
          newActiveKey = newPanes[lastIndex].url
        } else {
          newActiveKey = newPanes[0].url
        }
      }
      window.__history__ = window.__history__?.filter(h => h?.url != targetKey)
      setHistoryUrls(newPanes)
      setActiveKey(newActiveKey)
      newActiveKey != activeKey && app.go(newActiveKey)
    }
  }

  return (
    <Tabs type="editable-card" className='dashboard-nav-tabs' hideAdd={true} activeKey={activeKey} onChange={onChange} onEdit={onEdit}>
      {
        historyUrls?.map(u => <Tabs.TabPane closable={u.key != 'home'} tab={u.title} key={u.url} ></Tabs.TabPane>)
      }
    </Tabs>
  )
}

const paramSchema = {
  type: 'object',
  properties: {
    max: {
      type: 'number',
      title: '最大标签数',
      minimum: 1,
      description: '设置标签导航最大显示的数量，超过数量将不显示新标签，若未配置，将不限制。'
    }
  }
}

const NavTabs = {
  title: '标签导航',
  category: '页面元素',
  icon: require(`../icon/标签导航.svg`),
  component: NavTabsComponent,
  paramSchema,
  initLayout: { width: 500, height: 40 },
  theme: [
    { selector: '.dashboard-nav-tabs .ant-tabs-nav', title: '标签导航整体', config: ['background', 'border', 'layout'] },
    { selector: '.dashboard-nav-tabs .ant-tabs-nav .ant-tabs-nav-wrap .ant-tabs-tab', title: '标签', hiddenConfig: ['ali'] },
    { selector: '.dashboard-nav-tabs .ant-tabs-nav .ant-tabs-nav-wrap .ant-tabs-tab:hover', title: '标签悬停', config: ['background', 'font'], hiddenConfig: ['ali'] },
    { selector: '.dashboard-nav-tabs .ant-tabs-nav .ant-tabs-nav-wrap .ant-tabs-tab.ant-tabs-tab-active', title: '标签选中', config: ['background', 'font'], hiddenConfig: ['ali'] },
  ]
}

export default NavTabs
